import { Component, OnInit, ViewChild } from '@angular/core';
import { DetalleRegistro } from 'src/app/administracion/modelos/Asignacion_Equipo/detalle-registro';
import { MatTableDataSource } from '@angular/material/table';
import { Empleado } from 'src/app/administracion/modelos/empleado';
import { DetalleRegistroService } from 'src/app/administracion/servicios/Asignacion_Equipo/detalle-registro.service';
import { EquipoService } from 'src/app/administracion/servicios/Inventario/Equipo/equipo.service';
import { UsuarioService } from 'src/app/administracion/servicios';
import { ActivatedRoute, Router } from '@angular/router';
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { RegistroAsignacionEquipo } from 'src/app/administracion/modelos/Asignacion_Equipo/registro-asignacion-equipo';
import { RegistroAsignacionEquipoService } from 'src/app/administracion/servicios/Asignacion_Equipo/registro-asignacion-equipo.service';
import Swal from 'sweetalert2';
import { ItemComponenteService } from 'src/app/administracion/servicios/Inventario/Item_Componente/item-componente.service';
import { MatDialog } from '@angular/material/dialog';
import { VisualizarResponsivaComponent } from '../../Dialogs/Mantenimiento/visualizar-responsiva/visualizar-responsiva.component';
import { ItemComponente } from 'src/app/administracion/modelos/Inventario/Item_Componente/item-componente';
import { of, ReplaySubject, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { Perfil } from 'src/app/administracion/modelos/perfil';
import { Sucursal } from 'src/app/administracion/modelos/sucursal';
import { DocumentosService } from 'src/app/administracion/servicios/documentos.service';
import { SwalService } from 'src/app/administracion/servicios/swal.service';
import { VisorIneComponent } from '../asignaciones-equipo-usuario/visor-ine/visor-ine.component';

@Component({
  selector: 'app-detalle-asignacion-equipo-usuario',
  templateUrl: './detalle-asignacion-equipo-usuario.component.html',
  styleUrls: ['./detalle-asignacion-equipo-usuario.component.scss'],
})
export class DetalleAsignacionEquipoUsuarioComponent implements OnInit {
  @ViewChild(VisorIneComponent) visorIne?: VisorIneComponent;

  empleado_asignado: Empleado = new Empleado();
  empleado_gerente: Empleado = new Empleado();
  empleado_apoderado: Empleado = new Empleado();
  fecha_aux: string = new Date().toISOString().substring(0, 10);
  input_domicilio_colaborador = new FormControl();
  lista__Equipos: Equipo[] = [];

  /* Parámetros */
  id_registro: number = 0;
  id_colaborador: number = 0;
  id_administrador: number = 0;

  /*  Registro  lista de detalles */
  registroAsignacionEquipo: RegistroAsignacionEquipo =
    new RegistroAsignacionEquipo();
  lista_detalle_registro: DetalleRegistro[] = [];
  ietmComponente: ItemComponente = new ItemComponente();

  /* Empleado */
  input_gerente: FormControl = new FormControl();
  select_gerente: FormControl = new FormControl();
  listaColaboradores: Empleado[] = [];
  listaFiltradaColaboradores: ReplaySubject<Empleado[]> = new ReplaySubject<
    Empleado[]
  >(1);
  equipos_asignados: string = '';
  protected _onDestroy = new Subject<void>();
  /**Apoderado legal */
  input_apoderado: FormControl = new FormControl();
  select_apoderado: FormControl = new FormControl();
  listaColaboradoresApoderado: Empleado[] = [];
  listaFiltradaApoderado: ReplaySubject<Empleado[]> = new ReplaySubject<
    Empleado[]
  >(1);
  protected _onDestroyA = new Subject<void>();
  /* Vista */
  dataSource = new MatTableDataSource<DetalleRegistro>(
    [],
  ); /*  Contenido de la tabla     */
  encabezados: string[] = [
    'botones',
    'nombre del equipo',
    'tipo de equipo',
    'estatus',
    'observavciones',
  ]; /*  Encabezados de las tablas */
  @ViewChild('paginator', { static: true }) public paginator!: MatPaginator;
  inebandera = false; /*  Paginator de la tabla     */

  urlprueba: any;
  loadingColaboradores: boolean = true;

  flagNSerieCargador: boolean = false;
  nSerieCargador: any;
  flagResponsivaGeneral: boolean = false;
  flagResponsivaIndivual: boolean = false;
  showRPGeneral: number = 0;

  constructor(
    private readonly detalleRegistroService: DetalleRegistroService,
    private readonly equipoService: EquipoService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly registroAsignacionEquipoService: RegistroAsignacionEquipoService,
    private readonly router: Router,
    public readonly dialog: MatDialog,
    private readonly itemComponenteService: ItemComponenteService,
    private readonly usuarioService: UsuarioService,
    private readonly documentosService: DocumentosService,
    private readonly swalService: SwalService,
  ) {}

  ngOnInit() {
    this.parametros();
    this.llenarData();
    this.llenarListaColaboradores();
    //this.llenarListaApoderado()

    /*Comenzamos con el filtro de nombres de empleados */
    this.listaFiltradaColaboradores.next(this.listaColaboradores.slice());
    this.input_gerente.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEmpleado();
      });
    this.listaFiltradaApoderado.next(this.listaColaboradoresApoderado.slice());
    this.input_apoderado.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEmpleadoApoderado();
      });
  }
  reload() {
    location.reload();
  }

  /* RECIBIMOS LOS PARAMETROS ENVIADOS POR MEDIO DE LA URL Y LOS ALMACENAMOS EN VARIABLES DECLARADAS AL INCIO DE LA CLASE */
  parametros() {
    this.activatedRoute.params.subscribe((params) => {
      this.id_colaborador = params['id_colaborador'];
      this.id_administrador = params['id_administrador'];
      this.id_registro = params['id_registro'];
    });
  }

  /* Llena la lista de empleados del select search */
  llenarListaColaboradores() {
    /* Se consulta en el endpoint toos los empleados */
    this.usuarioService.getAllEmpleados().subscribe(
      /* se recorre la lista para construir el nombre completo */
      (lista_empleados) => {
        this.loadingColaboradores = false;
        lista_empleados.forEach((empleado) => {
          empleado.nomb_compl =
            empleado.nombre +
            ' ' +
            empleado.apellidoPat +
            ' ' +
            empleado.apellidoMat;
        });
        this.listaColaboradores = lista_empleados;
        this.listaColaboradoresApoderado = lista_empleados;
      },
      /* En caso que exista un error al mandar la peticióna, retorna un mensaje de error */
      (err) => {
        this.loadingColaboradores = false;
        this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
      },
    );
  }

  /* CARGA LA DATA DE LA VISTA: LOS DETALLES DE ASIGNACIÓN */
  llenarData() {
    /* Limpiamos el contenido de la tabla de equipos */
    this.dataSource.data.splice(0, this.dataSource.data.length);
    /* Limpiamos la lista de equipos */
    this.lista__Equipos.splice(0, this.lista__Equipos.length);
    /*Cargamos la data del registro general y los detalles de registro*/
    this.detalleRegistroService
      .listaDetallePorIdRegistro(this.id_registro)
      .pipe(
        switchMap((data) => {
          if (data.length == 0) {
            return of(data);
          }

          return this.usuarioService
            .getAnEmpleado(Number(data[0].registro.colaborador_id))
            .pipe(
              switchMap((empleado) => {
                this.empleado_asignado = empleado;
                return of(data);
              }),
            );
        }),
      )
      .subscribe((lista_detalles) => {
        this.lista_detalle_registro = lista_detalles;
        /*Se cargan los datos generales de la asignación y se da formato a las fechas */
        this.registroAsignacionEquipo = lista_detalles[0].registro;
        if (this.registroAsignacionEquipo.status_registro == 'REGISTRADO') {
          this.registroAsignacionEquipo.status_registro =
            'EN PROCESO DE ASIGNACIÓN (SIN RESPONSIVA)';
        }
        if (this.registroAsignacionEquipo.status_registro == 'ACTUALIZACION') {
          this.registroAsignacionEquipo.status_registro =
            'ACTUALIZACIÓN DE RESPONSIVA';
        }
        if (this.registroAsignacionEquipo.status_registro == 'CANCELACION') {
          this.registroAsignacionEquipo.status_registro =
            'EN PROCESO DE CANCELACIÓN';
        }
        this.registroAsignacionEquipo.fecha_asignacion_cadena =
          (this.registroAsignacionEquipo.fecha_asignacion + '').substring(
            8,
            10,
          ) +
          '-' +
          (this.registroAsignacionEquipo.fecha_asignacion + '').substring(
            5,
            7,
          ) +
          '-' +
          (this.registroAsignacionEquipo.fecha_asignacion + '').substring(0, 4);
        this.registroAsignacionEquipo.fecha_modificacion_cadena =
          (this.registroAsignacionEquipo.fecha_modificacion + '').substring(
            8,
            10,
          ) +
          '-' +
          (this.registroAsignacionEquipo.fecha_modificacion + '').substring(
            5,
            7,
          ) +
          '-' +
          (this.registroAsignacionEquipo.fecha_modificacion + '').substring(
            0,
            4,
          );

        // console.log(lista_detalles)
        /* Se hace una consulta a Glpi para traer los equipos pertenecientes a la lista de detalles*/
        this.lista_detalle_registro.forEach((detalle) => {
          /* Validamos que tipo de activo es el que tiene el detalle para consultarlo en Glpi */
          if (detalle.tipo_activo == 'COMPUTADORA') {
            this.equipoService
              .unEquipoExtends('Computer', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.computermodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Computer';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.computertypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.computermodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'DISPOSITIVO DE RED') {
            this.equipoService
              .unEquipoExtends('Networkequipment', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.networkequipmentmodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Networkequipment';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.networkequipmenttypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.networkequipmentmodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'IMPRESORA') {
            this.equipoService
              .unEquipoExtends('Printer', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.printermodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Printer';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.printertypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.printermodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'MONITOR') {
            this.equipoService
              .unEquipoExtends('Monitor', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.monitormodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Monitor';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.monitortypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.monitormodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'DISPOSITIVO') {
            this.equipoService
              .unEquipoExtends('Peripheral', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.peripheralmodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Peripheral';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.peripheraltypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.peripheralmodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'RACK') {
            this.equipoService
              .unEquipoExtends('Rack', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.rackmodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Rack';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.racktypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.rackmodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          } else if (detalle.tipo_activo == 'TELEFONO') {
            this.equipoService
              .unEquipoExtends('Phone', Number(detalle.equipo_id))
              .subscribe((equ) => {
                detalle.equipo = equ;
                equ.modelo = equ.phonemodels_id;
                equ.tipo = detalle.tipo_activo;
                detalle.equipo.tabla = 'Phone';
                this.equipos_asignados =
                  this.equipos_asignados +
                  equ.phonetypes_id +
                  ', MARCA ' +
                  equ.manufacturers_id +
                  ', MODELO ' +
                  equ.phonemodels_id +
                  ', SERIE ' +
                  equ.serial +
                  '';
                this.lista__Equipos.push(equ);
              });
          }

          /*valida que tenga responsiva en su espacio */
          if (detalle.archivo_responsiva) {
            detalle.responsiva = true;
          }

          /*valida que tenga responsiva en su espacio */
          if (detalle.status_detalle == 'CANCELADO') {
            detalle.bandera = true;
          }

          /*
              VALIDAMOS SI ENCUENTRA ALGUNA COMPUTADORA EN LA DATA SOURCE (YA SEA UNA LAPTOP O CPU)
              EN  CASO  QUE  ECNUNTRE  UNA COMPUTADORA, MANDARÁ UNA CONSULTA A GLPI PARA EXTRAER EL
              SISTEMA OPERATIVO ASÍ COMO LA ARQUITECTURA DEL MISMO, TODO ESTO SERÁ PARA AÑADIRLO EN
              LA REPSONSIVA DE EQUIPO
        */
          if (
            detalle.tipo_activo == 'COMPUTADORA' &&
            detalle.status_detalle == 'ACTIVO'
          ) {
            /*
                MANDA HACER LA CONSULTA A GLPI PARA LLAMAR TODOS LOS SISTEMAS OPERATIVOS QUE ESTAN INSTALADOS EN LAS
                DIFERENTES COMPUTADORAS
            */
            this.itemComponenteService
              .allSistemasOperativos()
              .subscribe((sistemas) => {
                /* DE LA CONSULTA RECIBIDA SE RECORRE CADA REGISTRO PARA BUSCAR EL SISTEMA QUE TIENE INSTALADO  ESTE
                EQUIPO, ESTO LO REALIZA COMPARANDO EL NOMBRE DEL EQUIPO EN EL QUE ESTA INSTALADO EL SISTEMA CON EL
                NOMBRE DEL EQUIPO QUE SE ENCUENTRA EN NUESTRO DETALLE DE ASIGNACIÓN
              */
                for (let i = 0; i < sistemas.length; i++) {
                  if (sistemas[i].items_id == detalle.nombre_equipo) {
                    /* CUANDO ENCUENTRE EL SISTEMA LO SALVA EN UN OBJETO DECLARADO AL INICIO DE ESTA CLASE
                    PARA SU POSTERIOR USO  Y TERMINA CON EL CICLO
                  */
                    this.ietmComponente = sistemas[i];
                    break;
                  }
                }
              });
          }
        });

        /*Carga la data de la tabla de detalles */
        this.dataSource.data = this.lista_detalle_registro;
        this.dataSource.paginator = this.paginator;

        // console.log(this.dataSource.data)
        this.necesitaCargador(this.dataSource.data);
      });
  }

  /* ABRE UNA VENTANA CON INFORMACÍON ACERCA DE LA VISTA */
  clickInformacion(event: any) {
    Swal.fire({
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      title: 'Instrucciones',
      html:
        '<p align="justify">El check añadir responsiva habilita un formulario para generar la responsiva de equipo correspondiente.</p>' +
        '<p align="justify">Para generar la responsiva de un equipo de cómputo se necesita que se llenen los campos del responsable que' +
        ' extiende la responsiva y el formulario donde se indican la dirección ip, mac y los programas instalados en el equipo ' +
        '(solo para las computadoras de escritorio y laptops).</p>' +
        '<p align="justify">Para generar la carta responsiva y anexo deberá rellenarse el campo nombre del responsable que' +
        ' extiende la responsiva y el formulario en donde indicamos el precio del equipo y el domicilio del colaborador, así como el nombre del apoderado legal de la empresa</p>' +
        '<p align="justify">Se puede guardar esta informaciòn haciendo click en el boton azul guardar, al igual que descargar ' +
        'los documentos al habiitarse los botones que se encuentran a un lado del nombre del documento que genera.</p>',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Cerrar',
    });
  }

  /*VALIDA SI REQUIERE N° SERIE CARGADOR */
  necesitaCargador(data: any[]) {
    //  console.log(data[0].archivo.equipo)
    // console.log(this.flagNSerieCargador)
    /** recorre el dato y busca el equipo y el tipo en caso de que sea un tipo portatil solicitará el N° de serie de cargador  */
    for (let index = 0; index < data.length; index++) {
      let element = data[index];
      //  console.warn(element.tipo_activo)
      // console.log(element.tipo_activo)
      //  console.log(element.equipo_id)
      // console.log(element.equipo) if()
      if (element.tipo_activo == 'COMPUTADORA')
        this.equipoService
          .unEquipo('Computer', element.equipo_id)
          .subscribe((response) => {
            //  console.log(response)
            //  console.log( element.equipo_id+" - "+response.computertypes_id)
            //Notebook =!                        // Laptop = 8                  || THINKPAD  == 11
            if (
              response.computertypes_id == '1' ||
              response.computertypes_id == '8' ||
              response.computertypes_id == '11'
            ) {
              this.flagNSerieCargador = true;
              console.log(response);
              // console.log( element.equipo_id+" - "+response.computertypes_id)
            }
          });
    }
  }

  /* RETORNA A LA VISTA EN DONDE SE NOS MUESTRA LAS ASIGANCIONES DEL COLABORADOR*/
  clickGoBack(event: any) {
    this.router.navigate([
      'layout/asignacionesEquipoUsuario/' + this.id_colaborador,
    ]);
  }

  async clickSubirResponsiva(id_detalle: number) {
    /* Emerge un input para solicitar la resposniva a subir */
    const { value: file } = await Swal.fire({
      title: 'Selecciona el archivo',
      input: 'file',
      inputAttributes: {
        accept: 'pdf/*',
      },
    });

    if (file) {
      /* valida que se subió un archivo y que el input file no se encuenetre vacío */
      if (file.type == 'application/pdf') {
        /* Valida que el archivo subido sea un pdf */
        if (file.size < 4194304) {
          /* Valida que el peso del archivo no sea superior al permitido 4 mb */
          /* Guarda la responsisva subida parar el equipo en particular */
          this.detalleRegistroService
            .subirResponsivaCarpeta(id_detalle, file)
            .subscribe(
              (data) => {
                Swal.fire({
                  title: 'Responsiva actualizada',
                  icon: 'success',
                  allowEnterKey: false,
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 2000,
                }).then((r) => {
                  this.llenarData();
                });
              },
              (error) => {
                console.log(error);
                Swal.fire('', 'Error ->' + error.error.error, 'error');
              },
            );
        } else {
          /* En caso que el archivo sea más grande retorna un mensaje de advertencia */
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'El archivo es muy grande para subirse.',
            showConfirmButton: false,
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 3000,
          });
        }
      } else {
        /* En caso que se esuba otro tipo de archivo, retorna un mensaje de error */
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Solo se permite subir archivos pdf.',
          showConfirmButton: false,
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 3000,
        });
      }
    }
  }

  /* Carga la responsisva de forma general en  */
  async clickSubirResponsivaComputadora(event: any) {
    /* Emerge un input para solicitar la resposniva a subir */
    const { value: file } = await Swal.fire({
      title: 'Selecciona el archivo',
      input: 'file',
      inputAttributes: {
        accept: 'pdf/*',
      },
    });

    if (file) {
      /* valida que se subió un archivo y que el input file no se encuenetre vacío */
      if (file.type == 'application/pdf') {
        /* Valida que el archivo subido sea un pdf */
        if (file.size < 1048576) {
          /* Valida que el peso del archivo no sea superior al permitido 1 mb */
          /* Recorre todos los detalles de asignacion de este registro de asignación */
          this.dataSource.data.forEach((contenido) => {
            /* Valida que la responsiva se suba solo en los detalles activos */
            if (contenido.status_detalle == 'ACTIVO') {
              /* Guarda la responsisva subida parar el equipo en particular */
              /* this.detalleRegistroService.subirResponsiva( Number(contenido.id_detalle_asignacion) , file ).subscribe(data=>{
                Swal.fire
                ({
                  title:'Responsiva actualizada',
                  icon:'success',
                  allowEnterKey:false,
                  allowEscapeKey:false,
                  allowOutsideClick:false,
                  showConfirmButton:false,
                  timer:2000
                }).then(r=>{
                  this.llenarData()
                })
              })*/
              this.detalleRegistroService
                .subirResponsivaCarpeta(
                  Number(contenido.id_detalle_asignacion),
                  file,
                )
                .subscribe(
                  (data) => {
                    Swal.fire({
                      title: 'Responsiva actualizada',
                      icon: 'success',
                      allowEnterKey: false,
                      allowEscapeKey: false,
                      allowOutsideClick: false,
                      showConfirmButton: false,
                      timer: 2000,
                    }).then((r) => {
                      this.llenarData();
                    });
                  },
                  (error) => {
                    Swal.fire(
                      '',
                      'Ocurrio un error, intentélo más tarde',
                      'error',
                    );
                  },
                );
            }
          });
        } else {
          /* En caso que el archivo sea más grande retorna un mensaje de advertencia */
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'El archivo es muy grande para subirse.',
            showConfirmButton: false,
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 3000,
          });
        }
      } else {
        /* En caso que se esuba otro tipo de archivo, retorna un mensaje de error */
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Solo se permite subir archivos pdf.',
          showConfirmButton: false,
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 3000,
        });
      }
    }
  }

  /* ABRE UNA VENTANA PARA VISUALIZAR LA RESPONSIVA CORRESPONDIENTE */
  clickDescargarResponsiva(detalleRegistro: DetalleRegistro) {
    this.detalleRegistroService
      .getbyResponsivaByID(detalleRegistro.id_detalle_asignacion!)
      .subscribe(
        (blob) => {
          var file = new Blob([blob], { type: 'application/pdf' });
          this.urlprueba = URL.createObjectURL(blob);
          const link = document.createElement('a');
          // window.open(this.urlprueba)
          //const dialogRef = this.dialog.open(VisualizarResponsivaComponent)
          link.href = this.urlprueba;
          link.download = `Responsiva de equipo.pdf`;
          link.click();
        },
        (error) => {
          console.log(error);
          Swal.fire('Error', 'Error al descargar el archivo ', 'error');
        },
      );

    /*const base64Data = detalleRegistro.archivo_responsiva + "";
    const base64Response = `data:data:application/pdf;base64,${base64Data}`;
    const link = document.createElement("a");
    link.href = base64Response;
    link.download = `Responsiva de equipo.pdf`
    link.click();*/
  }

  /* Se cancela un detalle de reistro */
  clickCancelarDetalleDeRegistro(
    id_equipo: number,
    tabla: string,
    detalleRegistro: DetalleRegistro,
  ) {
    /**SE ABRE UNA VENTANA CON UN MENSAJE E CONFIRMACIÓN */
    Swal.fire({
      title: '¿Quieres cancelar la asignación de este equipo?',
      icon: 'question',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'SÍ',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      /* Se valida que solo se realize lo siguiente si se confirmó la cancelación */
      if (result.isConfirmed) {
        /* Se cancela la asisgnación en Glpi */
        this.equipoService
          .buscarSucursal('CORPORATIVO')
          .subscribe((sucursales) => {
            /* Se declara el body para realiar el put en Glpi*/
            let body: string =
              '{"input": {"users_id": " ' +
              2 +
              ' ", "states_id": " ' +
              2 +
              ' ", "locations_id": " ' +
              sucursales[0].id +
              '"}}';
            /* Se hace la petición request */
            this.equipoService.actualizarItem(tabla, id_equipo, body).subscribe(
              (data) => {
                /* Despues de realizar la cancelación del equipo en Glpi se cancela el detalle de registro */
                detalleRegistro.status_detalle = 'CANCELADO';
                this.detalleRegistroService
                  .update(
                    detalleRegistro,
                    Number(detalleRegistro.registro.id_registro_asignacion),
                  )
                  .subscribe(
                    (detalle_registro_actualizado) => {
                      /* Ahora se valida si es un único equipo el asignado en este registro */
                      if (
                        this.dataSource.data.length == 1 &&
                        this.dataSource.data[0].archivo_responsiva == undefined
                      ) {
                        detalleRegistro.registro.status_registro = 'CANCELADO';
                        this.registroAsignacionEquipoService
                          .actualizacionRegistro(detalleRegistro.registro)
                          .subscribe(
                            (registro_actualizado) => {
                              this.mensajeDeExito(); /* Se llama al método que despliega un mensaje de éxito */
                              this.llenarData(); /* Cargamos la data del registro en la pantalla */
                            },
                            /* En caso que exista un error al mandar la peticióna, retorna un mensaje de error */
                            (err) => {
                              this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                            },
                          );
                      } else if (
                        /* Ahora se valida si es un único equipo el asignado en este registro */
                        this.dataSource.data.length == 1 &&
                        this.dataSource.data[0].archivo_responsiva != undefined
                      ) {
                        detalleRegistro.registro.status_registro =
                          'CANCELACION';
                        this.registroAsignacionEquipoService
                          .actualizacionRegistro(detalleRegistro.registro)
                          .subscribe(
                            (registro_actualizado) => {
                              this.mensajeDeExito(); /* Se llama al método que despliega un mensaje de éxito */
                              this.llenarData(); /* Cargamos la data del registro en la pantalla */
                            },
                            /* En caso que exista un error al mandar la peticióna, retorna un mensaje de error */
                            (err) => {
                              this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                            },
                          );
                      } else {
                        /* Si es parte de una computadora de escritorio solo retorna el mensaje de confirmación*/
                        detalleRegistro.registro.status_registro =
                          'ACTUALIZACION';
                        this.registroAsignacionEquipoService
                          .actualizacionRegistro(detalleRegistro.registro)
                          .subscribe(
                            (registro_actualizado) => {
                              this.mensajeDeExito(); /* Se llama al método que despliega un mensaje de éxito */
                              this.llenarData(); /* Cargamos la data del registro en la pantalla */
                            },
                            /* En caso que exista un error al mandar la peticióna, retorna un mensaje de error */
                            (err) => {
                              this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                            },
                          );
                      }
                    },
                    /* En caso que exista un error al mandar la peticióna, retorna un mensaje de error */
                    (err) => {
                      this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                    },
                  );
              },
              /* En caso que exista un error al mandar la peticióna Glpi, retorna un mensaje de error */
              (err) => {
                this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
              },
            );
          });
      }
    });
  }

  /* REDIRIGE A OTRA VENTANA EN DONDE PODREMOS ESCOGER OTRO COMPONENTE EN CASO DE QUE UN COMPONENTE DEL EQUIPO DE ESCRITORIO SEA CANCELADO*/
  clickAddEquipo(event: any) {
    let id_empleado: number = Number(this.empleado_asignado.idEmpleado);
    let nombre_completo: string =
      this.empleado_asignado.nombre +
      ' ' +
      this.empleado_asignado.apellidoPat +
      ' ' +
      this.empleado_asignado.apellidoMat;
    this.router.navigate([
      'layout/remplazoEquipo/' +
        this.id_registro +
        '/' +
        id_empleado +
        '/' +
        nombre_completo,
    ]);
  }

  /*  Cancela la asignación de una computadora de escritorio  */
  clickCancelarTodoElRegistro(event: any) {
    /* SE ABRE UNA VENTANA CON UN MENSAJE DE CONFIRMACIÓN */
    Swal.fire({
      title: '¿Quieres cancelar toda la asignación de este equipo?',
      icon: 'question',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'SÍ',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      /* Se valida que solo se realize lo siguiente si se confirmó la cancelación */
      if (result.isConfirmed) {
        /* Se recorre todo el registro */
        this.dataSource.data.forEach((detalle) => {
          /* Se cancela la asisgnación en Glpi */
          this.equipoService
            .buscarSucursal('CORPORATIVO')
            .subscribe((sucursales) => {
              /* Se declara el body para realiar el put en Glpi*/
              let body: string =
                '{"input": {"users_id": " ' +
                2 +
                ' ", "states_id": " ' +
                2 +
                ' ", "locations_id": " ' +
                sucursales[0].id +
                '"}}';
              /* Se hace la petición request */
              this.equipoService
                .actualizarItem(
                  detalle.equipo.tabla + '',
                  Number(detalle.equipo_id),
                  body,
                )
                .subscribe(
                  (data) => {
                    /* Despues de realizar la cancelación del equipo en Glpi se cancela el detalle de registro */
                    detalle.status_detalle = 'CANCELADO';
                    this.detalleRegistroService
                      .update(
                        detalle,
                        Number(detalle.registro.id_registro_asignacion),
                      )
                      .subscribe((data) => {
                        /* Se valida que si el registro ya fue cancelado */
                        if (detalle.registro.status_registro != 'CANCELADO') {
                          /* Si no está cancelado, cancela el registro */
                          detalle.registro.status_registro = 'CANCELACION';
                          this.registroAsignacionEquipoService
                            .actualizacionRegistro(detalle.registro)
                            .subscribe(
                              (registro) => {
                                this.llenarData();
                                this.mensajeDeExito(); /* Se llama al método que despliega un mensaje de éxito */
                              },
                              /* En caso que exista un error al mandar la peticióna Glpi, retorna un mensaje de error */
                              (err) => {
                                this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                              },
                            );
                        } else {
                          /* En caso de ya estar registrado se retorna un mensaje de confirmación */
                          this.mensajeDeExito(); /* Se llama al método que despliega un mensaje de éxito */
                        }
                      });
                  },
                  /* En caso que exista un error al mandar la peticióna Glpi, retorna un mensaje de error */
                  (err) => {
                    this.mensajeDeError(); /* Se llama al método que despliega un mensaje de error */
                  },
                );
            });
        });
      }
    });
  }

  /* ABRE UNA VENTANA PARA VISUALIZAR LA RESPONSIVA CORRESPONDIENTE */
  clickVerResponsiva(detalleRegistro: DetalleRegistro) {
    console.log(detalleRegistro);
    this.getFilesXnombre(detalleRegistro.id_detalle_asignacion!);
  }

  getFilesXnombre(id: number) {
    console.clear();
    this.detalleRegistroService.getbyResponsivaByID(id).subscribe(
      (blob) => {
        var file = new Blob([blob], { type: 'application/pdf' });
        this.urlprueba = URL.createObjectURL(blob);
        // window.open(this.urlprueba)
        const dialogRef = this.dialog.open(
          VisualizarResponsivaComponent /* Abre una ventana pasando todo en archivo en base 64 para visualiarlo */,
          {
            width: '900px',
            position: { top: '7%' },
            data: { url: this.urlprueba + '' },
          },
        );
      },
      (error) => {
        console.log(error);
        Swal.fire('Error', 'Error al descargar el archivo ', 'error');
      },
    );
  }

  /*Filtro que busca coincidencias dentro del select search */
  protected filterEmpleado() {
    if (!this.listaColaboradores) {
      return;
    }
    /* Recuperamos el valor del input */
    let search = this.input_gerente.value;
    if (!search) {
      this.listaFiltradaColaboradores.next(this.listaColaboradores.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    /* Retornamos sla lista de eempleados que cumplen con las coincidencias */
    this.listaFiltradaColaboradores.next(
      this.listaColaboradores.filter(
        (empleado) => empleado.nomb_compl.toLowerCase().indexOf(search) > -1,
      ),
    );
  }
  /*Filtro que busca coincidencias dentro del select search */
  protected filterEmpleadoApoderado() {
    if (!this.listaColaboradoresApoderado) {
      return;
    }
    /* Recuperamos el valor del input */
    let search = this.input_apoderado.value;
    if (!search) {
      this.listaFiltradaApoderado.next(
        this.listaColaboradoresApoderado.slice(),
      );
      return;
    } else {
      search = search.toLowerCase();
    }
    /* Retornamos sla lista de eempleados que cumplen con las coincidencias */
    this.listaFiltradaApoderado.next(
      this.listaColaboradoresApoderado.filter(
        (empleado) => empleado.nomb_compl.toLowerCase().indexOf(search) > -1,
      ),
    );
  }

  /* AL DAR CLICK EL REGISTRO PASA DE UN STATUS DE EN CANCELACIÓN A CANCELADO */
  clickBtnTerminarCancelacion(event: any) {
    /**SE PREGUNTA AL USUARIO SI QUIERE DAR POR TERMINADO EL PROCESO DE CANCELACIÓN, ESTO SIGNIDICA SI YA SE SUBIÓ LA DOSUCMENTACION CORRESPONDIENTE  */
    Swal.fire({
      title: '¿Marcar como terminado este pendiente de cancelación?',
      icon: 'info',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'SÍ',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then((result) => {
      /*
          EN CASO DE CONFIRMAR LA CANCELACIÓN SE PROCEDE A CAMBIAR EL STATUS A CANCELADO Y SE GUARDAN LOS CAMBIOS,
          ESTO HACE TAMBIEN QUE ESTE REGISTRO DEJE DE MOSTRARSE EN LOS PENDIENTES A ATENDER
          */
      if (result.isConfirmed) {
        this.registroAsignacionEquipo.status_registro = 'CANCELADO';
        this.registroAsignacionEquipoService
          .actualizacionRegistro(this.registroAsignacionEquipo)
          .subscribe((data) => {
            Swal.fire({
              title: 'Asignación cancelada',
              icon: 'success',
              allowEnterKey: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 2000,
            }).then((r) => {
              this.llenarData();
            });
          });
      }
    });
  }

  /* AL DAR CLICK EL REGISTRO PASA DE UN STATUS DE EN ACTUALIZACION/REGISTRADO A ACTIVO */
  clickBtnTerminarAsignacion(event: any) {
    Swal.fire({
      title: '¿Marcar pendiente como terminado?',
      icon: 'info',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'SÍ',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.registroAsignacionEquipo.status_registro = 'ACTIVO';
        this.registroAsignacionEquipoService
          .actualizacionRegistro(this.registroAsignacionEquipo)
          .subscribe((data) => {
            Swal.fire({
              title: 'Asignación actualizada',
              icon: 'success',
              allowEnterKey: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 2000,
            }).then((r) => {
              this.llenarData();
            });
          });
      }
    });
  }

  /* Devuelve un mensaje emergente de error */
  mensajeDeError() {
    Swal.fire({
      title: 'Error',
      text: 'Sin conexión, vuelva a intentarlo más tarde',
      icon: 'error',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: 3000,
    });
  }

  /* Devuelve un mensaje emergente de éxito */
  mensajeDeExito() {
    Swal.fire({
      title: 'Asignación cancelada',
      icon: 'success',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: 3000,
    });
  }

  habilitarBtnDescargarResponsiva() {
    /* Se valida que se escogio ya un empleado o gerente*/
    if (this.empleado_gerente.apellidoPat != undefined) {
      return true;
    }
    return false;
  }

  /* Se valida que se escogio ya un empleado o gerente*/
  habilitarBtnDescargarCartaYAnexo() {
    let res = this.empleado_asignado.folioIne?.replace(/ /g, '');
    let dir = this.dataSource.data[0].direccion_colaborador?.replace(/ /g, '');
    if (
      this.empleado_gerente.apellidoPat != undefined &&
      this.empleado_asignado.folioIne != undefined &&
      this.empleado_asignado.folioIne != '' &&
      this.dataSource.data[0].direccion_colaborador != undefined &&
      this.dataSource.data[0].direccion_colaborador != '' &&
      this.dataSource.data[0].precio != undefined &&
      res != '' &&
      this.empleado_asignado.folioIne != ' ' &&
      dir != '' &&
      this.dataSource.data[0].direccion_colaborador != ' '
    ) {
      return true;
    }
    return false;
  }

  /* Muestra el formulario para generar la carta  anexo */
  habiilitarFormularioEquipoPortatil() {
    // console.error(this.dataSource.data.length)
    if (this.dataSource.data.length == 1 || this.flagResponsivaIndivual) {
      return true;
    }
    return false;
  }

  /* Muestra el formulario para generar la carta  anexo */
  habiilitarFormularioComputadora() {
    if (this.dataSource.data.length > 1 || this.flagResponsivaGeneral) {
      return true;
    }
    return false;
  }

  /* HABILITA EL BOTON FINALIZAR ASIGNACIÓN */
  mostrarBtnTerminarAsignacion() {
    if (
      this.registroAsignacionEquipo.status_registro ==
        'EN PROCESO DE ASIGNACIÓN (SIN RESPONSIVA)' ||
      this.registroAsignacionEquipo.status_registro ==
        'ACTUALIZACIÓN DE RESPONSIVA'
    ) {
      return true;
    }
    return false;
  }

  /* HABILITA EL BOTON FINALIZAR ASIGNACIÓN */
  mostrarBtnTerminarCancelacion() {
    if (
      this.registroAsignacionEquipo.status_registro ==
      'EN PROCESO DE CANCELACIÓN'
    ) {
      return true;
    }
    return false;
  }

  /* Habilita paa vevr en pantala el botón rosa de la parte superior dela tabla*/
  mostrarBtnSubirResponsivaComputadoraYCancelarTodaLaAsignacion() {
    if (
      this.registroAsignacionEquipo.status_registro !=
        'EN PROCESO DE CANCELACIÓN' &&
      this.registroAsignacionEquipo.status_registro != 'CANCELADO' &&
      this.dataSource.data.length > 1
    ) {
      return true;
    }
    return false;
  }

  /* Habilita paa vevr en pantala el botón azul de la parte superior dela tabla*/
  mostrarBtnAgregarEquipo() {
    if (this.mostrarBtnSubirResponsivaComputadoraYCancelarTodaLaAsignacion()) {
      let contador: number = 0; /* Declaramos un contador para ver cuantos detalles estan activos */
      this.dataSource.data.forEach(
        (detalle /* Recorremos todos los detalles de la asignacion */) => {
          if (detalle.status_detalle == 'ACTIVO') {
            contador++;
          } /* Por cada detalle activo se suma 1 al contador */
        },
      );
      if (contador > 0 && contador < 5) {
        /* Validamos que solo sean 4 los equipos asignados */
        return true; /* Devuele verdadera */
      }
    }
    return false; /* Devuele falso */
  }

  descargarResponsivaGeneral() {
    this.empleado_asignado.nomb_compl =
      this.empleado_asignado.nombre +
      ' ' +
      this.empleado_asignado.apellidoPat +
      ' ' +
      this.empleado_asignado.apellidoMat;
    this.empleado_gerente.nomb_compl =
      this.empleado_gerente.nombre +
      ' ' +
      this.empleado_gerente.apellidoPat +
      ' ' +
      this.empleado_gerente.apellidoMat;
    /* Cuerpo y contenido de la tabla de la responsiva */
    const cuerpo: any[] = [];
    this.lista__Equipos.forEach((equipo) => {
      // console.log(equipo.id)
      let validacion = this.dataSource.data.find((ele: any) =>
        ele.equipo_id == equipo.id ? true : false,
      );
      if (validacion != null && validacion!.status_detalle != 'CANCELADO') {
        let fila: string[] = [];
        fila.push(equipo.tipo + '');
        fila.push(equipo.manufacturers_id + '');
        fila.push(equipo.modelo + '');
        fila.push(equipo.serial + '');
        fila.push(equipo.name + '');
        // fila.push(  equipo.comment          + "")
        cuerpo.push(fila);
      }
    });

    let fecha: string =
      this.fecha_aux.substring(8, 10) +
      '/' +
      this.fecha_aux.substring(5, 7) +
      '/' +
      this.fecha_aux.substring(0, 4);

    const data = {
      empleadoAsignado: this.registroAsignacionEquipo.nombre_empleado_asignado,
      puestoEmpleado: this.empleado_asignado.puesto.nombrePuesto,
      fecha,
      sucursal: this.empleado_asignado.sucursal.nombreSucursal,
      cuerpo,
      macAddress: this.dataSource.data[0].direccion_mac || '',
      version: this.ietmComponente.operatingsystems_id || '',
      direccionIP: this.dataSource.data[0].direccion_ip || '',
      versionBits: this.ietmComponente.operatingsystemarchitectures_id || '',
      versionOffice: this.dataSource.data[0].version_office || '',
      licenciaOffice: this.dataSource.data[0].licencia_office || '',
      programasInstalados: this.dataSource.data[0].programas_instalados || '',
      empleadoGerente: this.empleado_gerente.nomb_compl,
    };

    this.documentosService
      .descargarDocumento(
        `RESPONSIVA ${this.registroAsignacionEquipo.nombre_empleado_asignado}`,
        {
          archivo: 'responsiva_pc',
          data,
        },
      )
      .subscribe({
        next: () => {},
        error: (error) => {},
      });
  }

  descargarCartaResposiva() {
    this.nSerieCargador = this.dataSource.data[0].numero_serie_cargador;
    console.log(this.flagNSerieCargador);
    console.log(this.nSerieCargador);

    let nserie;
    if (this.flagNSerieCargador) {
      nserie = this.dataSource.data[0].numero_serie_cargador?.replace(/ /g, '');
      if (nserie == null || nserie.length == 0) {
        console.log('nserie ->' + nserie);
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes ',
          text: 'Debe ingresar numero de serie del cargador.',
          confirmButtonText: 'Aceptar',
          // footer: '<a href="#">Why do I have this issue?</a>'
        });
        return;
      }
    }

    /* Elementos para generar la fecha */
    let meses: string[] = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let fecha: string =
      this.fecha_aux.substring(8, 10) +
      ' ' +
      meses[Number(this.fecha_aux.substring(5, 7)) - 1] +
      ' ' +
      this.fecha_aux.substring(0, 4);
    /*Hace la conversion de cantidad numerica a escrita */
    this.dataSource.data[0].precio_nombre ==
      this.conversor(Number(this.dataSource.data[0].precio));
    /* Nombre del empleado que tiene asignado el equipo */
    this.empleado_asignado.nomb_compl =
      this.empleado_asignado.nombre +
      ' ' +
      this.empleado_asignado.apellidoPat +
      ' ' +
      this.empleado_asignado.apellidoMat;
    /* Contenido del pdf */
    this.validarEmpleado(this.empleado_asignado);
    this.validarEmpleado(this.empleado_gerente);
    console.log('->', this.registroAsignacionEquipo);
    this.registroAsignacionEquipo.nombre_empleado_asignado =
      this.empleado_asignado.nomb_compl;

    this.documentosService
      .descargarDocumento(
        `CARTA RESPONSIVA ${this.registroAsignacionEquipo.nombre_empleado_asignado}`,
        {
          archivo: 'carta_responsiva',
          data: {
            hora: (new Date() + '').substring(16, 21),
            fecha,
            empleadoAsignado:
              this.registroAsignacionEquipo.nombre_empleado_asignado,
            folioIne: this.empleado_asignado.folioIne,
            puesto: this.empleado_asignado.puesto.nombrePuesto,
            domicilio: this.dataSource.data[0].direccion_colaborador,
            apoderado: this.empleado_apoderado.nomb_compl,
            precio: this.dataSource.data[0].precio,
            precioLetra: this.conversor(Number(this.dataSource.data[0].precio)),
            numeroSerie:
              this.equipos_asignados +
              '' +
              (this.flagNSerieCargador && this.nSerieCargador != null
                ? ' Y CARGADOR CON NUMERO DE SERIE: ' +
                  this.nSerieCargador +
                  '.'
                : ''),
          },
        },
      )
      .subscribe({
        next: () => {},
        error: (error) => {},
      });
  }

  descargarAnexoResponsiva() {
    this.nSerieCargador = this.dataSource.data[0].numero_serie_cargador;
    // console.log(this.flagNSerieCargador)
    // console.log(this.nSerieCargador)

    let nserie;
    if (this.flagNSerieCargador) {
      nserie = this.dataSource.data[0].numero_serie_cargador?.replace(/ /g, '');
      if (nserie == null || nserie.length == 0) {
        console.log('nserie ->' + nserie);
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes ',
          text: 'Debe ingresar numero de serie del cargador.',
          confirmButtonText: 'Aceptar',
          // footer: '<a href="#">Why do I have this issue?</a>'
        });
        return;
      }
    }

    // console.log(this.dataSource.data[0].numero_serie_cargador)
    this.validarEmpleado(this.empleado_asignado);
    this.validarEmpleado(this.empleado_gerente);
    /* Elementos para generar la fecha */
    let meses: string[] = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let fecha: string =
      this.fecha_aux.substring(8, 10) +
      ' ' +
      meses[Number(this.fecha_aux.substring(5, 7)) - 1] +
      ' ' +
      this.fecha_aux.substring(0, 4);
    /* Define la razon de la carta responsiva */
    let tipo_activo_: string = '';
    if (this.dataSource.data[0].tipo_activo == 'COMPUTADORA') {
      tipo_activo_ = 'ENTREGA DE NOTEBOOK';
    } else if (this.dataSource.data[0].tipo_activo == 'DISPOSITIVO') {
      tipo_activo_ =
        'ENTREGA DE ' + this.dataSource.data[0].equipo.peripheraltypes_id;
    } else if (this.dataSource.data[0].tipo_activo == 'DISPOSITIVO DE RED') {
      tipo_activo_ =
        'ENTREGA DE ' + this.dataSource.data[0].equipo.networkequipmenttypes_id;
    } else {
      tipo_activo_ = 'ENTREGA DE ' + this.dataSource.data[0].tipo_activo;
    }

    this.documentosService
      .descargarDocumento(
        `ANEXO DE CARTA RESPONSIVA ${this.registroAsignacionEquipo.nombre_empleado_asignado}`,
        {
          archivo: 'anexo_responsiva',
          data: {
            fecha,
            empleadoAsignado:
              this.registroAsignacionEquipo.nombre_empleado_asignado,
            puestoEmpleado: this.empleado_asignado.puesto.nombrePuesto || '',
            tipoActivo: tipo_activo_,
            gerenteNombre: `${this.empleado_gerente.nombre} ${
              this.empleado_gerente.apellidoPat
            } ${this.empleado_gerente.apellidoMat || ''}`,
            gerenteNombreCompleto: this.empleado_gerente.nomb_compl,
            puestoGerente: this.empleado_gerente?.puesto?.nombrePuesto || '',
            equipo:
              this.equipos_asignados +
              '' +
              (this.flagNSerieCargador && this.nSerieCargador != null
                ? ' Y CARGADOR CON NUMERO DE SERIE: ' +
                  this.nSerieCargador +
                  '.'
                : ''),
          },
        },
      )
      .subscribe({
        next: () => {},
        error: (error) => {},
      });
  }

  /* AL DAR CLICK TODO LO INGRESADO EN LOS FORMULARIOS SE GUARDA DENTRO DEL DETALLE DE LA RESPONSIVA */
  async clickActualizarDatosResponsiva(event: any) {
    // console.log("this.flagNSerieCargador)

    if (
      (this.flagNSerieCargador &&
        this.dataSource.data[0].numero_serie_cargador == null) ||
      (this.flagNSerieCargador &&
        this.dataSource.data[0].numero_serie_cargador?.trim()?.length == 0)
    ) {
      // console.log(this.dataSource.data[0])
      // console.log(this.dataSource.data[0].nSerieCargador)
      // console.error("error")
      Swal.fire({
        icon: 'error',
        title: 'Campos faltantes',
        text: 'Debe ingresar el numero de serie del cargador',
        confirmButtonText: 'Aceptar',
        // footer: '<a href="#">Why do I have this issue?</a>'
      });

      return;
    }
    // console.log(this.dataSource.data[0].numero_serie_cargador)
    let nserie = this.dataSource.data[0].numero_serie_cargador;
    // console.log(nserie)
    // console.log(this.dataSource.data[0])
    /* PEDIMOS CONFIRMACIÓN */

    const result = await Swal.fire({
      icon: 'question',
      text: '¿Quieres guardar la información agregada?',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'SÍ',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    });

    /* EN CASO DE TENER CONFIRMACIÓN */
    if (!result.isConfirmed) {
      return;
    }

    /* ACTUALIZAMOS LOS CAMPOS PERTENECIENTES A ESTE DETALLE DE ASIGNACIÓN */
    this.detalleRegistroService
      .update(
        this.dataSource.data[0],
        Number(this.dataSource.data[0].registro.id_registro_asignacion),
      )
      .pipe(
        switchMap((resp) => {
          if (
            this.habiilitarFormularioEquipoPortatil() &&
            this.empleado_asignado.idEmpleado &&
            this.empleado_asignado.folioIne
          ) {
            return this.usuarioService.actualizarFolioIne(
              this.empleado_asignado.idEmpleado,
              this.empleado_asignado.folioIne,
            );
          }

          return of(resp);
        }),
      )
      .subscribe(
        (resultado) => {
          console.log(resultado);
          /* LANZAMOS UN MENSAJE DE REALIZADO Y VOLVEMOS A CARGAR LOS DATOS DEL DETALLE */
          this.swalService.operacionExitosa('Actualización realizada');
        } /* En caso de existir algun error de conexión se realiza lo siguiente */,
        (err) => {
          this.mensajeDeError(); /* Retornamos un mensaje de errir */
        },
      );
  }

  checkbandera: boolean = false; /* Elementos del check */
  bandera: boolean = false; /* Elemento para habilitar todo el formulario */
  onCheckboxChange(event: any /* Metodo que muestra u oculta el formularos*/) {
    if (this.bandera == false) {
      this.bandera = true;
    } else {
      this.bandera = false;
    }
  }

  /* CARGA LOS DATOS DEL GERENTE QUE EXTIENDE LA RESPONSIVA */
  clickSelectResponsableExtiendeResponsiva(event: any) {
    console.log('.-', event.value);
    let puesto: Perfil = new Perfil();
    puesto.nombrePuesto = '';
    // this.nombre_empleado_asignado=event.value.nombre
    this.empleado_gerente =
      event.value; /* Valida que el puesto no sea nulo o vacío */
    if (this.empleado_gerente.puesto == null) {
      this.empleado_gerente.puesto = puesto;
    } /* de ser vacío o nulo agrega un valor por defecto */

    if (
      this.empleado_asignado.folioIne != undefined ||
      this.empleado_asignado.folioIne != ''
    )
      this.inebandera = true;
  }
  /* CARGA LOS DATOS DEL GERENTE QUE EXTIENDE LA RESPONSIVA */
  clickSelectResponsableExtiendeResponsivaApoderado(event: any) {
    console.log(event.value);
    let puesto: Perfil = new Perfil();
    puesto.nombrePuesto = '';
    // this.nombre_empleado_asignado=event.value.nombre
    this.empleado_apoderado =
      event.value; /* Valida que el puesto no sea nulo o vacío */
    if (this.empleado_apoderado.puesto == null) {
      this.empleado_gerente.puesto = puesto;
    } /* de ser vacío o nulo agrega un valor por defecto */
  }

  /* RETORNA EL VALOR DE LA CANTIDAD INGESADA EN UNIDADES  */
  private unidad(unidad: number) {
    if (unidad == 0) {
      return '';
    } else if (unidad == 1) {
      return 'UNO';
    } else if (unidad == 2) {
      return 'DOS';
    } else if (unidad == 3) {
      return 'TRES';
    } else if (unidad == 4) {
      return 'CUATRO';
    } else if (unidad == 5) {
      return 'CINCO';
    } else if (unidad == 6) {
      return 'SEIS';
    } else if (unidad == 7) {
      return 'SIETE';
    } else if (unidad == 8) {
      return 'OCHO';
    } else if (unidad == 9) {
      return 'NUEVE';
    } else {
      return '';
    }
  }

  /* RETORNA EL VALOR DE LA CANTIDAD INGESADA EN DECENAS  */
  private decena(decena: number, unidad: number) {
    /* VALIDA SI SON CANTIDADES CERRADAS */
    if (decena == 0) {
      return '';
    } else if (decena == 1 && unidad == 0) {
      return 'DIEZ ';
    } else if (decena == 2 && unidad == 0) {
      return 'VEINTE ';
    } else if (decena == 3 && unidad == 0) {
      return 'TREINTA ';
    } else if (decena == 4 && unidad == 0) {
      return 'CUARENTA ';
    } else if (decena == 5 && unidad == 0) {
      return 'CINCUENTA ';
    } else if (decena == 6 && unidad == 0) {
      return 'SESENTA ';
    } else if (decena == 7 && unidad == 0) {
      return 'SETENTA ';
    } else if (decena == 8 && unidad == 0) {
      return 'OCHENTA ';
    } else if (decena == 9 && unidad == 0) {
      return 'NOVENTA ';
    } else if (decena == 1 && unidad == 1) {
      /** VALIDAMOS SI SE ENCUENTRA DELL RANGO DE 11 A 19 */
      return 'ONCE';
    } else if (decena == 1 && unidad == 2) {
      return 'DOCE';
    } else if (decena == 1 && unidad == 3) {
      return 'TRECE';
    } else if (decena == 1 && unidad == 4) {
      return 'CATORCE';
    } else if (decena == 1 && unidad == 5) {
      return 'QUINCE';
    } else if (decena == 1 && unidad >= 6) {
      return 'DIECI';
    } else if (decena == 2 && unidad >= 0) {
      /** VALIDAMOS QUE SE ENCUENTRE DE 20 A 90 */
      return 'VEINTI';
    } else if (decena == 3 && unidad >= 0) {
      return 'TREINTA y ';
    } else if (decena == 4 && unidad >= 0) {
      return 'CUARENTA y ';
    } else if (decena == 5 && unidad >= 0) {
      return 'CINCUENTA y ';
    } else if (decena == 6 && unidad >= 0) {
      return 'SESENTA y ';
    } else if (decena == 7 && unidad >= 0) {
      return 'SETENTA y ';
    } else if (decena == 8 && unidad >= 0) {
      return 'OCHENTA y ';
    } else if (decena == 9 && unidad >= 0) {
      return 'NOVENTA y ';
    } else {
      return '';
    }
  }

  /* RETORNA EL VALOR DE LA CANTIDAD INGESADA EN CENTENAS  */
  private centena(centena: number, decena: number, unidad: number) {
    /** PRIMERO VALIDAMOS SI ES 100 CERRADO */
    if (centena == 1 && decena == 0 && unidad == 0) {
      return 'CIEN';
    } else if (
      /** VALIDAMOS SI ES MÁS DE 100 HASTA 900 */
      (centena == 1 && decena > 0) ||
      (centena == 1 && unidad > 0) ||
      (centena == 1 && decena > 0 && decena > 0)
    ) {
      return 'CIENTO ';
    } else if (centena == 2) {
      return 'DOSCIENTOS ';
    } else if (centena == 3) {
      return 'TRESCIENTOS ';
    } else if (centena == 4) {
      return 'CUATROCIENTOS ';
    } else if (centena == 5) {
      return 'QUINIENTOS ';
    } else if (centena == 6) {
      return 'SEISCIENTOS ';
    } else if (centena == 7) {
      return 'SETECIENTOS ';
    } else if (centena == 8) {
      return 'OCHOCIENTOS ';
    } else if (centena == 9) {
      return 'NOVECIENTOS ';
    } else if (decena > 0) {
      return this.decena(decena, unidad);
    } else if (unidad > 0) {
      return this.unidad(unidad);
    } else {
      return '';
    }
  }

  /* RETORNA EL VALOR DE LA CANTIDAD INGESADA EN UNIDADES DE MILLAR  */
  private unidad_de_millar(unidad_millar: number) {
    if (unidad_millar == 1) {
      return 'MIL ';
    } else if (unidad_millar == 2) {
      return 'DOS MIL ';
    } else if (unidad_millar == 3) {
      return 'TRES MIL ';
    } else if (unidad_millar == 4) {
      return 'CUATRO MIL ';
    } else if (unidad_millar == 5) {
      return 'CINCO MIL ';
    } else if (unidad_millar == 6) {
      return 'SEIS MIL ';
    } else if (unidad_millar == 7) {
      return 'SIETE MIL ';
    } else if (unidad_millar == 8) {
      return 'OCHO MIL ';
    } else if (unidad_millar == 9) {
      return 'NUEVE MIL ';
    } else {
      return '';
    }
  }

  /* RETORNA EL VALOR DE LA CANTIDAD INGESADA EN DECENAS DE MILLAR  */
  private decena_de_millar(decena: number, unidad: number) {
    /** VALIDAMOS SI SON CANTIDADES CERRADAS */
    if (decena == 1 && unidad == 0) {
      return 'DIEZ MIL ';
    } else if (decena == 2 && unidad == 0) {
      return 'VEINTE MIL ';
    } else if (decena == 3 && unidad == 0) {
      return 'TREINTA MIL ';
    } else if (decena == 4 && unidad == 0) {
      return 'CUARENTA MIL ';
    } else if (decena == 5 && unidad == 0) {
      return 'CINCUENTA MIL ';
    } else if (decena == 6 && unidad == 0) {
      return 'SESENTA MIL ';
    } else if (decena == 7 && unidad == 0) {
      return 'SETENTA MIL ';
    } else if (decena == 8 && unidad == 0) {
      return 'OCHENTA MIL ';
    } else if (decena == 9 && unidad == 0) {
      return 'NOVENTA MIL ';
    } else if (decena == 1 && unidad == 1) {
      /** VALIDAMOS SI PERTENECEN AL RANDO DE 11 A 19 */
      return 'ONCE MIL ';
    } else if (decena == 1 && unidad == 2) {
      return 'DOCE MIL ';
    } else if (decena == 1 && unidad == 3) {
      return 'TRECE MIL ';
    } else if (decena == 1 && unidad == 4) {
      return 'CATORCE MIL ';
    } else if (decena == 1 && unidad == 5) {
      return 'QUINCE MIL ';
    } else if (decena == 1 && unidad == 6) {
      return 'DIECISEIS MIL ';
    } else if (decena == 1 && unidad == 7) {
      return 'DIECISIETE MIL ';
    } else if (decena == 1 && unidad == 8) {
      return 'DIECIOCHO MIL ';
    } else if (decena == 1 && unidad == 9) {
      return 'DIECINUEVE MIL ';
    } else if (decena == 2 && unidad == 1) {
      /** VALIDAMOS QUE PERTENESCA AL RANGO DE 21, 31, . . .91 */
      return 'VEINTIUN MIL ';
    } else if (decena == 3 && unidad == 1) {
      return 'TREINTA Y UN MIL ';
    } else if (decena == 4 && unidad == 1) {
      return 'CUARENTA Y UN MIL ';
    } else if (decena == 5 && unidad == 1) {
      return 'CINCUENTA Y UN MIL ';
    } else if (decena == 6 && unidad == 1) {
      return 'SESENTA Y UN MIL ';
    } else if (decena == 7 && unidad == 1) {
      return 'SETENTA Y UN MIL ';
    } else if (decena == 8 && unidad == 1) {
      return 'OCHENTA Y UN MIL ';
    } else if (decena == 9 && unidad == 1) {
      return 'NOVENTA Y UN MIL ';
    } else if (decena == 2 && unidad >= 1) {
      /** VALIDAMOS QUE PERTENESCA AL RANGO DE 22 - 90 */
      return 'VEINTI' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 3 && unidad >= 1) {
      return 'TREINTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 4 && unidad >= 1) {
      return 'CUARENTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 5 && unidad >= 1) {
      return 'CINCUENTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 6 && unidad >= 1) {
      return 'SESENTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 7 && unidad >= 1) {
      return 'SETENTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 8 && unidad >= 1) {
      return 'OCHENTA y ' + this.unidad(unidad) + ' MIL ';
    } else if (decena == 9 && unidad >= 1) {
      return 'NOVENTA y ' + this.unidad(unidad) + ' MIL ';
    } else {
      return '';
    }
  }

  /** RETORNAMOS EL VALOR REPRESENTADO EN LETRAS */
  conversor(precio: number) {
    /** DECLARAMOS UNA CADENA QUE VAA A CONTENER EL PRECIO EN LETRA */
    let precio_letra: string = '';

    /** ALBERGAMOS LA CANTIDAD EN UNA CADENA PARA COMPRAR SU TAMAÑO EN CARACTERES. */
    let auxiliar: string = precio + '';

    if (auxiliar.length == 1) {
      precio_letra = this.unidad(precio);
    } else if (auxiliar.length == 2) {
      if (Number(auxiliar[0]) == 1 && Number(auxiliar[1]) < 6) {
        precio_letra = this.decena(Number(auxiliar[0]), Number(auxiliar[1]));
      } else {
        precio_letra =
          this.decena(Number(auxiliar[0]), Number(auxiliar[1])) +
          this.unidad(Number(auxiliar[1]));
      }
    } else if (auxiliar.length == 3) {
      if (Number(auxiliar[1]) == 1 && Number(auxiliar[2]) < 6) {
        precio_letra =
          this.centena(
            Number(auxiliar[0]),
            Number(auxiliar[1]),
            Number(auxiliar[2]),
          ) + this.decena(Number(auxiliar[1]), Number(auxiliar[2]));
      } else {
        precio_letra =
          this.centena(
            Number(auxiliar[0]),
            Number(auxiliar[1]),
            Number(auxiliar[2]),
          ) +
          this.decena(Number(auxiliar[1]), Number(auxiliar[2])) +
          this.unidad(Number(auxiliar[2]));
      }
    } else if (auxiliar.length == 4) {
      if (Number(auxiliar[2]) == 1 && Number(auxiliar[3]) < 6) {
        precio_letra =
          this.unidad_de_millar(Number(auxiliar[0])) +
          this.centena(
            Number(auxiliar[1]),
            Number(auxiliar[2]),
            Number(auxiliar[3]),
          ) +
          this.decena(Number(auxiliar[2]), Number(auxiliar[3]));
      } else {
        precio_letra =
          this.unidad_de_millar(Number(auxiliar[0])) +
          this.centena(
            Number(auxiliar[1]),
            Number(auxiliar[2]),
            Number(auxiliar[3]),
          ) +
          this.decena(Number(auxiliar[2]), Number(auxiliar[3])) +
          this.unidad(Number(auxiliar[3]));
      }
    } else if (auxiliar.length == 5) {
      if (Number(auxiliar[3]) == 1 && Number(auxiliar[4]) < 6) {
        precio_letra =
          this.decena_de_millar(Number(auxiliar[0]), Number(auxiliar[1])) +
          this.centena(
            Number(auxiliar[2]),
            Number(auxiliar[3]),
            Number(auxiliar[4]),
          ) +
          this.decena(Number(auxiliar[3]), Number(auxiliar[4]));
      } else {
        precio_letra =
          this.decena_de_millar(Number(auxiliar[0]), Number(auxiliar[1])) +
          this.centena(
            Number(auxiliar[2]),
            Number(auxiliar[3]),
            Number(auxiliar[4]),
          ) +
          this.decena(Number(auxiliar[3]), Number(auxiliar[4])) +
          this.unidad(Number(auxiliar[4]));
      }
    }

    return precio_letra;
  }

  /* Con esté método revisamos que el empleado cuente con todos los dataos necesarios para generar las responsivas
  y en caso de no poseer un dato  se pueda asignar un valor por defecto */
  validarEmpleado(empleado: Empleado) {
    let oficina: Sucursal = new Sucursal();
    let puesto: Perfil = new Perfil();

    oficina.nombreSucursal = ' ';
    puesto.nombrePuesto = ' ';

    if (empleado.puesto == null || empleado.puesto.nombrePuesto == undefined) {
      empleado.puesto = puesto;
    }
    if (
      empleado.sucursal == null ||
      empleado.sucursal.nombreSucursal == undefined
    ) {
      empleado.sucursal = oficina;
    }
    if (empleado.folioIne == undefined) {
      empleado.folioIne = '';
    }
  }

  mostrarRPGeneral() {
    //console.log("ok");
    this.showRPGeneral++;
    this.flagResponsivaIndivual = false;
    this.flagResponsivaGeneral = false;
    //console.log(this.showRPGeneral)
    //this.showRPGeneral=this.showRPGeneral++;
  }
}
